import type { CSSProperties, ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

const tile: CSSProperties = {
  display: 'grid',
  placeItems: 'center',
  width: 64,
  height: 64,
  borderRadius: '50%',
  color: 'var(--paige-link)',
  background: 'color-mix(in srgb, var(--paige-accent) 13%, transparent)',
};

/**
 * The picture over a whole-screen state (nothing at this address, a screen that could not be opened): its
 * icon in the accent's soft circle, so the state leads with a picture and one line, as CPv6's do.
 */
export function StateMark({ icon: Icon }: { icon: LucideIcon }): ReactNode {
  return (
    <span style={tile}>
      <Icon size={28} strokeWidth={1.75} />
    </span>
  );
}
